module.exports = __webpack_public_path__ + "img/enca.70c067f8.png";